import React from 'react';
import './SerialNumberDialogue.scss';
import { Icons } from '../../utilities/Icons/Icons';

const SerialNumberDialogue = props => (
  <div className='serial-number-outer-container'>
    <button
      type='button'
      style={{
        border: 'none',
        background: 'none',
        outline: 'none'
      }}
      onClick={() => {
        props.closeAction(null);
      }}
    >
      <img
        src={Icons.seria_number_info}
        alt='serial number'
        style={{ width: '90%' }}
      />
    </button>
  </div>
);

export default SerialNumberDialogue;
